window.mcb = window.mcb || {};
window.mcb.regno = (function () {
    const _logger = window.mcb.utilities.createLogger('regno', 'Registration Numbers');

    const init = function (targetId, data, settings) {
        _logger.log('Initializing Registration Numbers');

        const searchEl = document.querySelector('#search');
        const entriesPerPageEl = document.querySelector('#entriesPerPage');
        const registreringsnummerEl = document.querySelector('#registreringsnummer');
        const hregEl = document.querySelector('#hreg');
        const navnEl = document.querySelector('#navn');
        const postnummerEl = document.querySelector('#postnummer');

        const target = document.getElementById(targetId);
        target.innerHTML = `<table id="table-${targetId}" class="display nowrap table table-striped" style="width:100%"></table>`;

        const ageTarget = document.getElementById("mcb-webpart-age");
        ageTarget.innerHTML = "Opdateret: <br />" + `${formatDate(new Date(data.age))}`;

        const columns = [];
        data.fields.forEach((field) => {
            if (field.alias == "name") {
                columns.push({
                    data: 'adress',
                    name: "adress",
                    title: "Adresse",
                    render: (data, type, row, meta) => {
                        return row.name + "<br />" + row.adress + "<br />" + row.areacode + " " + row.area;
                    },
                    visible: true,
                    className: 'wrap-text adress-column',
                    orderData: columns.length,
                });
            }

            if (!columns.some(e => e.data === field.alias)) {
                columns.push({
                    data: field.alias,
                    name: field.alias,
                    title: field.label,
                    visible: isVisible(field.alias),
                    className: getClassName(field.alias)
                });
            }
        });
        _logger.log("columns: ", columns);

        createEntriesPerPage([10, 25, 50, 100, 1000]);

        const table = createTable(targetId, data.data, columns, parseInt(entriesPerPageEl.value), 'hregno')

        table.responsive.recalc();

        // filtering function
        table.search.fixed('range', function (searchStr, data, index) {
            let regno = data.regno.includes(registreringsnummerEl.value);
            let hregno = data.hregno.includes(hregEl.value);
            let name = data.name.toLowerCase().includes(navnEl.value?.toLowerCase());
            let areacode = data.areacode.includes(postnummerEl.value);

            return (regno && hregno && name && areacode);
        });

        [registreringsnummerEl, hregEl, navnEl, postnummerEl].forEach(elem => {
            elem.addEventListener('input', function () {
                table.draw();
            });
        })

        searchEl.addEventListener('keyup', function () {
            table.search(this.value).draw();
        });

        entriesPerPageEl.addEventListener('change', function () {
            let value = $(this).val();
            table.page.len(value).draw();
        });

        return table;
    }

    const createTable = (targetId, data, columns, pageLength, orderBy) => {
        return $(`#table-${targetId}`).DataTable({
            data: data,
            columns: columns,
            responsive: false,
            pageLength: pageLength,
            scrollX: true,
            dom: 'rtip',
            autoWidth: false,
            order: {
                name: orderBy,
                dir: 'asc'
            }
        });
    }

    const isVisible = (alias => {
        return alias == 'regno' ||
            alias == 'hregno' ||
            alias == 'department' ||
            alias == 'phone' ||
            alias == 'fax'

    })

    const getClassName = (alias) => {
        if (alias == 'phone' ||
            alias == 'fax') {
            return '';
        }
        else {
            return 'wrap-text';
        }
    }

    const createEntriesPerPage = (entries) => {
        let select = document.getElementById('entriesPerPage');
        entries.forEach(entry => {
            select.options[select.options.length] = new Option(entry, entry);
        })
    }

    const formatDate = (date) => {
        let dd = String(date.getDate()).padStart(2, '0');
        let mm = String(date.getMonth() + 1).padStart(2, '0');
        let yyyy = date.getFullYear();

        return `${dd}-${mm}-${yyyy}`;
    }

    return {
        init: init
    }
})();
